var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toast',{style:({ width: _vm.$isMobile() ? '85vw' : '' })}),_c('ConfirmDialog',{attrs:{"group":"dialogSendFleetFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }